module.exports = __webpack_public_path__ + "img/2.fedb99d5.jpg";